/* tslint:disable */
/* eslint-disable */
/**
 * Thynk Direct API
 * The API for managing reservation for [Thynk Direct](https://thynk.cloud/).
 *
 * The version of the OpenAPI document: 4.22.9
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base';
// @ts-ignore
import { BookingBookingBillingRead } from '../model';
// @ts-ignore
import { BookingJsonldBookingStatusWrite } from '../model';
// @ts-ignore
import { BookingRead } from '../model';
// @ts-ignore
import { BookingReservationCancelBookingWrite } from '../model';
// @ts-ignore
import { BookingWrite } from '../model';
/**
 * BookingApi - axios parameter creator
 * @export
 */
export const BookingApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Creates a BookingReservationCancel resource.
     * @summary Cancel a reservation
     * @param {string} id BookingReservationCancel identifier
     * @param {BookingReservationCancelBookingWrite} bookingReservationCancelBookingWrite The new BookingReservationCancel resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bookingReservationCancel: async (
      id: string,
      bookingReservationCancelBookingWrite: BookingReservationCancelBookingWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('bookingReservationCancel', 'id', id);
      // verify required parameter 'bookingReservationCancelBookingWrite' is not null or undefined
      assertParamExists(
        'bookingReservationCancel',
        'bookingReservationCancelBookingWrite',
        bookingReservationCancelBookingWrite,
      );
      const localVarPath = `/api/booking/reservation/{id}/cancel`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bookingReservationCancelBookingWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Creates a BookingReservationRequestProposal resource.
     * @summary Request proposal a reservation
     * @param {string} id BookingReservationRequestProposal identifier
     * @param {object} body The new BookingReservationRequestProposal resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bookingReservationRequestProposal: async (
      id: string,
      body: object,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('bookingReservationRequestProposal', 'id', id);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('bookingReservationRequestProposal', 'body', body);
      const localVarPath =
        `/api/booking/reservation/{id}/request_proposal`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(id)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Creates a BookingReservationTurndown resource.
     * @summary Turndown a reservation
     * @param {string} id BookingReservationTurndown identifier
     * @param {object} body The new BookingReservationTurndown resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bookingReservationTurndown: async (
      id: string,
      body: object,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('bookingReservationTurndown', 'id', id);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('bookingReservationTurndown', 'body', body);
      const localVarPath = `/api/booking/reservation/{id}/turndown`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Replaces the Booking resource.
     * @summary Update booking status
     * @param {string} id Booking identifier
     * @param {BookingJsonldBookingStatusWrite} bookingJsonldBookingStatusWrite The updated Booking resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bookingUpdateStatus: async (
      id: string,
      bookingJsonldBookingStatusWrite: BookingJsonldBookingStatusWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('bookingUpdateStatus', 'id', id);
      // verify required parameter 'bookingJsonldBookingStatusWrite' is not null or undefined
      assertParamExists(
        'bookingUpdateStatus',
        'bookingJsonldBookingStatusWrite',
        bookingJsonldBookingStatusWrite,
      );
      const localVarPath = `/api/booking/{id}/status`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bookingJsonldBookingStatusWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves a Booking resource.
     * @summary Retrieve reservation booking billing
     * @param {string} id Booking identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsBookingBillingGet: async (
      id: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('reservationsBookingBillingGet', 'id', id);
      const localVarPath = `/api/booking/{id}/billing`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves a Booking resource.
     * @summary Retrieve reservation booking confirmation page
     * @param {string} id Booking identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsBookingConfirmationGet: async (
      id: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('reservationsBookingConfirmationGet', 'id', id);
      const localVarPath = `/api/booking/{id}/confirmation`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves a Booking resource.
     * @summary Retrieves a Booking resource.
     * @param {string} id Booking identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsBookingGet: async (
      id: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('reservationsBookingGet', 'id', id);
      const localVarPath = `/api/booking/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates the Booking resource.
     * @summary Update an existing reservation booking
     * @param {string} id Booking identifier
     * @param {BookingWrite} bookingWrite The updated Booking resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsBookingPatch: async (
      id: string,
      bookingWrite: BookingWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('reservationsBookingPatch', 'id', id);
      // verify required parameter 'bookingWrite' is not null or undefined
      assertParamExists(
        'reservationsBookingPatch',
        'bookingWrite',
        bookingWrite,
      );
      const localVarPath = `/api/booking/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bookingWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Creates a Booking resource.
     * @summary Create a new reservation booking
     * @param {BookingWrite} bookingWrite The new Booking resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsBookingPost: async (
      bookingWrite: BookingWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bookingWrite' is not null or undefined
      assertParamExists(
        'reservationsBookingPost',
        'bookingWrite',
        bookingWrite,
      );
      const localVarPath = `/api/booking`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bookingWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Replaces the Booking resource.
     * @summary Update an existing reservation booking
     * @param {string} id Booking identifier
     * @param {BookingWrite} bookingWrite The updated Booking resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsBookingPut: async (
      id: string,
      bookingWrite: BookingWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('reservationsBookingPut', 'id', id);
      // verify required parameter 'bookingWrite' is not null or undefined
      assertParamExists('reservationsBookingPut', 'bookingWrite', bookingWrite);
      const localVarPath = `/api/booking/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bookingWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BookingApi - functional programming interface
 * @export
 */
export const BookingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BookingApiAxiosParamCreator(configuration);
  return {
    /**
     * Creates a BookingReservationCancel resource.
     * @summary Cancel a reservation
     * @param {string} id BookingReservationCancel identifier
     * @param {BookingReservationCancelBookingWrite} bookingReservationCancelBookingWrite The new BookingReservationCancel resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bookingReservationCancel(
      id: string,
      bookingReservationCancelBookingWrite: BookingReservationCancelBookingWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.bookingReservationCancel(
          id,
          bookingReservationCancelBookingWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['BookingApi.bookingReservationCancel']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Creates a BookingReservationRequestProposal resource.
     * @summary Request proposal a reservation
     * @param {string} id BookingReservationRequestProposal identifier
     * @param {object} body The new BookingReservationRequestProposal resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bookingReservationRequestProposal(
      id: string,
      body: object,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.bookingReservationRequestProposal(
          id,
          body,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['BookingApi.bookingReservationRequestProposal']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Creates a BookingReservationTurndown resource.
     * @summary Turndown a reservation
     * @param {string} id BookingReservationTurndown identifier
     * @param {object} body The new BookingReservationTurndown resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bookingReservationTurndown(
      id: string,
      body: object,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.bookingReservationTurndown(
          id,
          body,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['BookingApi.bookingReservationTurndown']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Replaces the Booking resource.
     * @summary Update booking status
     * @param {string} id Booking identifier
     * @param {BookingJsonldBookingStatusWrite} bookingJsonldBookingStatusWrite The updated Booking resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bookingUpdateStatus(
      id: string,
      bookingJsonldBookingStatusWrite: BookingJsonldBookingStatusWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.bookingUpdateStatus(
          id,
          bookingJsonldBookingStatusWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['BookingApi.bookingUpdateStatus']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves a Booking resource.
     * @summary Retrieve reservation booking billing
     * @param {string} id Booking identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reservationsBookingBillingGet(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BookingBookingBillingRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.reservationsBookingBillingGet(
          id,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['BookingApi.reservationsBookingBillingGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves a Booking resource.
     * @summary Retrieve reservation booking confirmation page
     * @param {string} id Booking identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reservationsBookingConfirmationGet(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BookingBookingBillingRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.reservationsBookingConfirmationGet(
          id,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['BookingApi.reservationsBookingConfirmationGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves a Booking resource.
     * @summary Retrieves a Booking resource.
     * @param {string} id Booking identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reservationsBookingGet(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.reservationsBookingGet(id, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['BookingApi.reservationsBookingGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Updates the Booking resource.
     * @summary Update an existing reservation booking
     * @param {string} id Booking identifier
     * @param {BookingWrite} bookingWrite The updated Booking resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reservationsBookingPatch(
      id: string,
      bookingWrite: BookingWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.reservationsBookingPatch(
          id,
          bookingWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['BookingApi.reservationsBookingPatch']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Creates a Booking resource.
     * @summary Create a new reservation booking
     * @param {BookingWrite} bookingWrite The new Booking resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reservationsBookingPost(
      bookingWrite: BookingWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.reservationsBookingPost(
          bookingWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['BookingApi.reservationsBookingPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Replaces the Booking resource.
     * @summary Update an existing reservation booking
     * @param {string} id Booking identifier
     * @param {BookingWrite} bookingWrite The updated Booking resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reservationsBookingPut(
      id: string,
      bookingWrite: BookingWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.reservationsBookingPut(
          id,
          bookingWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['BookingApi.reservationsBookingPut']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * BookingApi - factory interface
 * @export
 */
export const BookingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BookingApiFp(configuration);
  return {
    /**
     * Creates a BookingReservationCancel resource.
     * @summary Cancel a reservation
     * @param {BookingApiBookingReservationCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bookingReservationCancel(
      requestParameters: BookingApiBookingReservationCancelRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .bookingReservationCancel(
          requestParameters.id,
          requestParameters.bookingReservationCancelBookingWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Creates a BookingReservationRequestProposal resource.
     * @summary Request proposal a reservation
     * @param {BookingApiBookingReservationRequestProposalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bookingReservationRequestProposal(
      requestParameters: BookingApiBookingReservationRequestProposalRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .bookingReservationRequestProposal(
          requestParameters.id,
          requestParameters.body,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Creates a BookingReservationTurndown resource.
     * @summary Turndown a reservation
     * @param {BookingApiBookingReservationTurndownRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bookingReservationTurndown(
      requestParameters: BookingApiBookingReservationTurndownRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .bookingReservationTurndown(
          requestParameters.id,
          requestParameters.body,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Replaces the Booking resource.
     * @summary Update booking status
     * @param {BookingApiBookingUpdateStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bookingUpdateStatus(
      requestParameters: BookingApiBookingUpdateStatusRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .bookingUpdateStatus(
          requestParameters.id,
          requestParameters.bookingJsonldBookingStatusWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves a Booking resource.
     * @summary Retrieve reservation booking billing
     * @param {BookingApiReservationsBookingBillingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsBookingBillingGet(
      requestParameters: BookingApiReservationsBookingBillingGetRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<BookingBookingBillingRead> {
      return localVarFp
        .reservationsBookingBillingGet(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves a Booking resource.
     * @summary Retrieve reservation booking confirmation page
     * @param {BookingApiReservationsBookingConfirmationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsBookingConfirmationGet(
      requestParameters: BookingApiReservationsBookingConfirmationGetRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<BookingBookingBillingRead> {
      return localVarFp
        .reservationsBookingConfirmationGet(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves a Booking resource.
     * @summary Retrieves a Booking resource.
     * @param {BookingApiReservationsBookingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsBookingGet(
      requestParameters: BookingApiReservationsBookingGetRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<BookingRead> {
      return localVarFp
        .reservationsBookingGet(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates the Booking resource.
     * @summary Update an existing reservation booking
     * @param {BookingApiReservationsBookingPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsBookingPatch(
      requestParameters: BookingApiReservationsBookingPatchRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<BookingRead> {
      return localVarFp
        .reservationsBookingPatch(
          requestParameters.id,
          requestParameters.bookingWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Creates a Booking resource.
     * @summary Create a new reservation booking
     * @param {BookingApiReservationsBookingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsBookingPost(
      requestParameters: BookingApiReservationsBookingPostRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<BookingRead> {
      return localVarFp
        .reservationsBookingPost(requestParameters.bookingWrite, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Replaces the Booking resource.
     * @summary Update an existing reservation booking
     * @param {BookingApiReservationsBookingPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsBookingPut(
      requestParameters: BookingApiReservationsBookingPutRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<BookingRead> {
      return localVarFp
        .reservationsBookingPut(
          requestParameters.id,
          requestParameters.bookingWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for bookingReservationCancel operation in BookingApi.
 * @export
 * @interface BookingApiBookingReservationCancelRequest
 */
export interface BookingApiBookingReservationCancelRequest {
  /**
   * BookingReservationCancel identifier
   * @type {string}
   * @memberof BookingApiBookingReservationCancel
   */
  readonly id: string;

  /**
   * The new BookingReservationCancel resource
   * @type {BookingReservationCancelBookingWrite}
   * @memberof BookingApiBookingReservationCancel
   */
  readonly bookingReservationCancelBookingWrite: BookingReservationCancelBookingWrite;
}

/**
 * Request parameters for bookingReservationRequestProposal operation in BookingApi.
 * @export
 * @interface BookingApiBookingReservationRequestProposalRequest
 */
export interface BookingApiBookingReservationRequestProposalRequest {
  /**
   * BookingReservationRequestProposal identifier
   * @type {string}
   * @memberof BookingApiBookingReservationRequestProposal
   */
  readonly id: string;

  /**
   * The new BookingReservationRequestProposal resource
   * @type {object}
   * @memberof BookingApiBookingReservationRequestProposal
   */
  readonly body: object;
}

/**
 * Request parameters for bookingReservationTurndown operation in BookingApi.
 * @export
 * @interface BookingApiBookingReservationTurndownRequest
 */
export interface BookingApiBookingReservationTurndownRequest {
  /**
   * BookingReservationTurndown identifier
   * @type {string}
   * @memberof BookingApiBookingReservationTurndown
   */
  readonly id: string;

  /**
   * The new BookingReservationTurndown resource
   * @type {object}
   * @memberof BookingApiBookingReservationTurndown
   */
  readonly body: object;
}

/**
 * Request parameters for bookingUpdateStatus operation in BookingApi.
 * @export
 * @interface BookingApiBookingUpdateStatusRequest
 */
export interface BookingApiBookingUpdateStatusRequest {
  /**
   * Booking identifier
   * @type {string}
   * @memberof BookingApiBookingUpdateStatus
   */
  readonly id: string;

  /**
   * The updated Booking resource
   * @type {BookingJsonldBookingStatusWrite}
   * @memberof BookingApiBookingUpdateStatus
   */
  readonly bookingJsonldBookingStatusWrite: BookingJsonldBookingStatusWrite;
}

/**
 * Request parameters for reservationsBookingBillingGet operation in BookingApi.
 * @export
 * @interface BookingApiReservationsBookingBillingGetRequest
 */
export interface BookingApiReservationsBookingBillingGetRequest {
  /**
   * Booking identifier
   * @type {string}
   * @memberof BookingApiReservationsBookingBillingGet
   */
  readonly id: string;
}

/**
 * Request parameters for reservationsBookingConfirmationGet operation in BookingApi.
 * @export
 * @interface BookingApiReservationsBookingConfirmationGetRequest
 */
export interface BookingApiReservationsBookingConfirmationGetRequest {
  /**
   * Booking identifier
   * @type {string}
   * @memberof BookingApiReservationsBookingConfirmationGet
   */
  readonly id: string;
}

/**
 * Request parameters for reservationsBookingGet operation in BookingApi.
 * @export
 * @interface BookingApiReservationsBookingGetRequest
 */
export interface BookingApiReservationsBookingGetRequest {
  /**
   * Booking identifier
   * @type {string}
   * @memberof BookingApiReservationsBookingGet
   */
  readonly id: string;
}

/**
 * Request parameters for reservationsBookingPatch operation in BookingApi.
 * @export
 * @interface BookingApiReservationsBookingPatchRequest
 */
export interface BookingApiReservationsBookingPatchRequest {
  /**
   * Booking identifier
   * @type {string}
   * @memberof BookingApiReservationsBookingPatch
   */
  readonly id: string;

  /**
   * The updated Booking resource
   * @type {BookingWrite}
   * @memberof BookingApiReservationsBookingPatch
   */
  readonly bookingWrite: BookingWrite;
}

/**
 * Request parameters for reservationsBookingPost operation in BookingApi.
 * @export
 * @interface BookingApiReservationsBookingPostRequest
 */
export interface BookingApiReservationsBookingPostRequest {
  /**
   * The new Booking resource
   * @type {BookingWrite}
   * @memberof BookingApiReservationsBookingPost
   */
  readonly bookingWrite: BookingWrite;
}

/**
 * Request parameters for reservationsBookingPut operation in BookingApi.
 * @export
 * @interface BookingApiReservationsBookingPutRequest
 */
export interface BookingApiReservationsBookingPutRequest {
  /**
   * Booking identifier
   * @type {string}
   * @memberof BookingApiReservationsBookingPut
   */
  readonly id: string;

  /**
   * The updated Booking resource
   * @type {BookingWrite}
   * @memberof BookingApiReservationsBookingPut
   */
  readonly bookingWrite: BookingWrite;
}

/**
 * BookingApi - object-oriented interface
 * @export
 * @class BookingApi
 * @extends {BaseAPI}
 */
export class BookingApi extends BaseAPI {
  /**
   * Creates a BookingReservationCancel resource.
   * @summary Cancel a reservation
   * @param {BookingApiBookingReservationCancelRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BookingApi
   */
  public bookingReservationCancel(
    requestParameters: BookingApiBookingReservationCancelRequest,
    options?: AxiosRequestConfig,
  ) {
    return BookingApiFp(this.configuration)
      .bookingReservationCancel(
        requestParameters.id,
        requestParameters.bookingReservationCancelBookingWrite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Creates a BookingReservationRequestProposal resource.
   * @summary Request proposal a reservation
   * @param {BookingApiBookingReservationRequestProposalRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BookingApi
   */
  public bookingReservationRequestProposal(
    requestParameters: BookingApiBookingReservationRequestProposalRequest,
    options?: AxiosRequestConfig,
  ) {
    return BookingApiFp(this.configuration)
      .bookingReservationRequestProposal(
        requestParameters.id,
        requestParameters.body,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Creates a BookingReservationTurndown resource.
   * @summary Turndown a reservation
   * @param {BookingApiBookingReservationTurndownRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BookingApi
   */
  public bookingReservationTurndown(
    requestParameters: BookingApiBookingReservationTurndownRequest,
    options?: AxiosRequestConfig,
  ) {
    return BookingApiFp(this.configuration)
      .bookingReservationTurndown(
        requestParameters.id,
        requestParameters.body,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Replaces the Booking resource.
   * @summary Update booking status
   * @param {BookingApiBookingUpdateStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BookingApi
   */
  public bookingUpdateStatus(
    requestParameters: BookingApiBookingUpdateStatusRequest,
    options?: AxiosRequestConfig,
  ) {
    return BookingApiFp(this.configuration)
      .bookingUpdateStatus(
        requestParameters.id,
        requestParameters.bookingJsonldBookingStatusWrite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves a Booking resource.
   * @summary Retrieve reservation booking billing
   * @param {BookingApiReservationsBookingBillingGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BookingApi
   */
  public reservationsBookingBillingGet(
    requestParameters: BookingApiReservationsBookingBillingGetRequest,
    options?: AxiosRequestConfig,
  ) {
    return BookingApiFp(this.configuration)
      .reservationsBookingBillingGet(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves a Booking resource.
   * @summary Retrieve reservation booking confirmation page
   * @param {BookingApiReservationsBookingConfirmationGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BookingApi
   */
  public reservationsBookingConfirmationGet(
    requestParameters: BookingApiReservationsBookingConfirmationGetRequest,
    options?: AxiosRequestConfig,
  ) {
    return BookingApiFp(this.configuration)
      .reservationsBookingConfirmationGet(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves a Booking resource.
   * @summary Retrieves a Booking resource.
   * @param {BookingApiReservationsBookingGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BookingApi
   */
  public reservationsBookingGet(
    requestParameters: BookingApiReservationsBookingGetRequest,
    options?: AxiosRequestConfig,
  ) {
    return BookingApiFp(this.configuration)
      .reservationsBookingGet(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Updates the Booking resource.
   * @summary Update an existing reservation booking
   * @param {BookingApiReservationsBookingPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BookingApi
   */
  public reservationsBookingPatch(
    requestParameters: BookingApiReservationsBookingPatchRequest,
    options?: AxiosRequestConfig,
  ) {
    return BookingApiFp(this.configuration)
      .reservationsBookingPatch(
        requestParameters.id,
        requestParameters.bookingWrite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Creates a Booking resource.
   * @summary Create a new reservation booking
   * @param {BookingApiReservationsBookingPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BookingApi
   */
  public reservationsBookingPost(
    requestParameters: BookingApiReservationsBookingPostRequest,
    options?: AxiosRequestConfig,
  ) {
    return BookingApiFp(this.configuration)
      .reservationsBookingPost(requestParameters.bookingWrite, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Replaces the Booking resource.
   * @summary Update an existing reservation booking
   * @param {BookingApiReservationsBookingPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BookingApi
   */
  public reservationsBookingPut(
    requestParameters: BookingApiReservationsBookingPutRequest,
    options?: AxiosRequestConfig,
  ) {
    return BookingApiFp(this.configuration)
      .reservationsBookingPut(
        requestParameters.id,
        requestParameters.bookingWrite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
